// A deploy replaces the hashed chunk files, so a tab opened before it asks for
// a chunk that no longer exists. Every browser words that failure differently,
// and none of them says "your bundle is stale":
//   Chrome   Failed to fetch dynamically imported module: <url>
//   Firefox  error loading dynamically imported module
//   Safari   Importing a module script failed
//   Safari   Cross-origin script load denied by Cross-Origin Resource Sharing policy
// The last one is why these reach Sentry as an apparent CORS bug (see
// PLATFORM-LCM-5PJ / 5PH, 4 events, 100% Safari, 100% prod).
const CHUNK_LOAD_MESSAGES = [
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "cross-origin script load denied",
  "loading chunk",
  "loading css chunk",
];

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message.toLowerCase();
  return CHUNK_LOAD_MESSAGES.some((candidate) => message.includes(candidate));
}
